<template>
<div class="position-relative mt-3" id="coverCategoryTable">

  <div class="actions text-right" id="coverCategoryTable-showAddEditDialog">
    <button class="btn btn-primary icon-button" @click="showAddEditDialog = true" id="coverCategoryTable-add-Button">
      <span class="btn-icon" id="coverCategoryTable-addButton-span"><i class="fa fa-plus" aria-hidden="true" id="coverCategoryTable-addButton-data"></i></span>
      {{ 'ADD' | translate }}
    </button>
  </div>

  <vodal :show="showAddEditDialog"
         :width="400"
         :closeOnEsc="true"
         :closeOnClickMask="false"
         :customStyles="{'top': '80px', 'bottom': 'auto', 'height': 'auto'}"
         animation="rotate"
         @hide="closeDialog">
    <coverCategory-add-edit-dialog :edited="editedRow"
                              :covers="covers"
                              :coverCategorys="coverCategorys"
                              @save="onSaveNew"
                              @update="onUpdate"
                              @close="closeDialog"
                              :errortype="error"
                              id="coverCategoryTable-addEditDialog"
    ></coverCategory-add-edit-dialog>
  </vodal>
  <table class="table table-striped table-hover" id="coverCategoryTable-tableData">
    <!-- <caption>Productline table</caption> -->
    <tr>
      <th>Dekking</th>
      <th>{{ "Category" | translate }}</th>
      <th>Omschrijving</th>
      <th> {{ 'BACKOFFICE_CODE_INCOMING' | translate }} </th>
      <th> {{ 'BACKOFFICE_CODE_OUTGOING' | translate }}</th>
      <th> {{ 'AFD_CODE' | translate }}</th>
      <th>Enabled</th>
      <th></th>
    </tr>
    <template v-for="row in rows">
      <tr>
        <td>{{ row.coverType }}</td>
        <td>{{ row.category }}</td>
        <td>{{ row.description }}</td>
        <td><div v-for="(backofficeCodeIncoming, index) in row.backofficeCodeIncoming" :key="index" class="backofficeCodeOutgoing-item">
                  {{ backofficeCodeIncoming }}
         </div></td>
        <td>{{ row.backofficeCodeOutgoing }}</td>
        <td>{{ row.afdCode }}</td>
        <td>{{ row.enabled }}</td>
        <td id="coverCategoryTable-tableButtons">
          <button class="btn btn-success icon-button icon-button-collapsed"
              v-tooltip="$options.filters.translate('EDIT')" @click="onEdit(row)" :id="'coverCategoryTable-tableEditButton-'+row.coverType">
            <span class="btn-icon" :id="'coverCategoryTable-tableEditSpan-'+row.coverType"><i class="fa fa-pencil" aria-hidden="true" :id="'coverCategoryTable-tableEditData-'+row.coverType"></i></span>
          </button>
          <button class="btn btn-danger icon-button icon-button-collapsed"
              v-tooltip="$options.filters.translate('DELETE')" @click="confirmDelete(row)" :id="'coverCategoryTable-tableDeleteButton-'+row.coverType">
            <span class="btn-icon" :id="'coverCategoryTable-tableDeleteSpan-'+row.coverType"><i class="fa fa-trash-o" aria-hidden="true" :id="'coverCategoryTable-tableDeleteData-'+row.coverType"></i></span>
          </button>
        </td>
      </tr>
    </template>
  </table>
  <confirm-dialog :show="showDeleteConfirmDialog" :textLabel="'Are you sure you want to delete this?'"
          @hide-dialog="showDeleteConfirmDialog = false" @confirm="onRemove(selectedRow.coverType)">
          </confirm-dialog>
</div>
</template>

<script>
import RestService from '../../../service/RestService.js';
import CoverCategoryAddEditDialog from './CoverCategoryAddEditDialog';
import Datepicker from 'vuejs-datepicker';
import Vodal from 'vodal';
import ConfirmDialog from '../../dialog/ConfirmDialog.vue';

export default {
  components: { CoverCategoryAddEditDialog, Datepicker, Vodal, ConfirmDialog },
  data() {
    return {
      rest: this.initRestService(),
      filter: '',
      rows: [],
      newRows: [],
      editedRow: null,
      covers: [],
      coverCategorys: [],
      showAddEditDialog: false,
      showDeleteConfirmDialog: false,
      selectedRow: null,
      error: null
    }
  },
  beforeMount() {
    this.loadRows();
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    async loadRows() {
      const coverCategoryResponse = await this.rest.getAllCoverCategoryRows();
      this.rows = coverCategoryResponse.data;
    },
    async onSaveNew(row) {
      try {
        await this.rest.createCoverCategoryRow(row);
        this.closeDialog();
        this.loadRows();
      } catch (error) {
        if (error.response && error.response.status === 409) {
          this.setError('ERROR_DUPLICATE_RECORD');
        } else {
          this.setError('ERROR_DURING_OPERATION');
        }
        this.$log.error(error.response ? error.response.data : error);
      }
    },
    async onUpdate(row) {
      await this.rest.updateCoverCategoryRow(row);
      this.closeDialog();
      this.loadRows();
    },
    onEdit(row) {
      this.editedRow = { ...row };
      this.showAddEditDialog = true;
    },
    onRemove(rowId) {
      this.rows = this.rows.filter(row => row.coverType !== rowId);
      this.rest.deleteCoverCategoryRow(rowId);
      this.showDeleteConfirmDialog = false;
    },
    closeDialog() {
      this.showAddEditDialog = false;
      this.editedRow = false;
    },
    confirmDelete(row) {
      this.selectedRow = row;
      this.showDeleteConfirmDialog = true;
    },
    setError(errorMessage) {
      this.error = errorMessage;
      setTimeout(() => {
        this.error = false;
      }, 5000);
    }
  }
}
</script>

<style lang="scss" scoped>
  >>> .vue-table {
    border: 0;

    th, td {
      border-right: 0;
      border-bottom: 0;
      border-left: 0;
    }

    thead > tr > th {
      padding-right: .75rem;
      padding-left: 30px !important;
    }

    .arrow:before {
      bottom: 12px;
      right: auto;
      left: 12px;
      font-family: 'FontAwesome';
    }

    .icon-button {
      opacity: 0;
      transition: opacity .1s ease-out;
    }

    tr:hover .icon-button {
      opacity: 1;
    }
  }

  .actions {
    position: absolute;
    z-index: 1;
    top: 10px;
    right: 0;

    .icon-button {
      padding-right: 15px;
      padding-left: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/cover-category/CoverCategoryTable.vue